import { Header as SharedHeader } from '@selina-finance/ui';

interface HeaderProps {
    className?: string;
}

const Header = ({ className }: HeaderProps) => (
    <SharedHeader className={className} />
);

export default Header;
